import * as Sentry from '@sentry/react';
import { browserTracingIntegration, replayIntegration } from '@sentry/react';

const replay = replayIntegration({
  maskAllText: true,
  blockAllMedia: true,
  maskAllInputs: true,
});

const shouldDropTelemetryMessage = (message: string) => {
  const normalized = (message || '').toLowerCase();
  return (
    normalized.includes('enabledidusertypeonkeyboardlogging') ||
    normalized.includes('java object is gone') ||
    normalized.includes('iabjs://navigation_performance_logger_android')
  );
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: (process.env.NODE_ENV || 'development') + '-' + process.env.REACT_APP_SITE_NAME,
  integrations: [browserTracingIntegration(), replay],
  // Não grava sessões "normais" — o Replay fica em buffer e só é ENVIADO
  // quando ocorre um erro. Assim só consumimos a cota de replays (50/mês no
  // plano free) com sessões que realmente tiveram problema.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  tracesSampleRate: 1,
  enableLogs: true,
  enableMetrics: true,
  beforeSendLog(log) {
    const candidateMessage =
      typeof log.message === 'string'
        ? log.message
        : JSON.stringify(log.message || '').toLowerCase();
    if (shouldDropTelemetryMessage(candidateMessage)) {
      return null;
    }

    return log;
  },
  beforeSendMetric(metric) {
    const name = String(metric.name || '').toLowerCase();
    if (!name) {
      return null;
    }

    if (name.includes('enabledidusertypeonkeyboardlogging')) {
      return null;
    }

    return metric;
  },
});
